import Progress from './Progress';

export default Progress;
export { Progress };
export type { ProgressProps } from './type';
